// extracted by mini-css-extract-plugin
module.exports = {"cta":"_16JKuVp1","disabled":"Vcsg4xXE","primary":"_9gdXMScd","transparent":"RPZAT8cb","secondary":"_2xFZD42z","fullWidth":"wrt3PX7P","small":"_3Ha6kZqV","spinner":"_3LQUMgz-"};